import {Box, Hide, HStack, Show, Text, useDevice} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

import i18n from '../../../i18n/i18n';
import {AvailableCar} from '../../../types/AvailableCar';
import {PriceReportType} from '../../../types/PriceReportType';
import {getDifference} from '../../../utils/getDifference';
import {HorizontalValue, HorizontalValueProps} from './HorizontalValue';
import {VerticalValue, VerticalValueProps} from './VerticalValue';

interface VehicleCardContentYearProps extends TestIdProps {
  vehicle: AvailableCar;
  priceReport: PriceReportType;
  isMyVehicle: boolean;
}

export function VehicleCardContentYear(props: VehicleCardContentYearProps) {
  const isMobile = useDevice() === 'mobile';

  const yearDifference = getDifference(
    props.vehicle.year,
    props.priceReport?.vehicle.firstRegistrationOnYear
  );

  const valueProps: VerticalValueProps | HorizontalValueProps = {
    value: props.vehicle.year,
    difference: props.isMyVehicle ? undefined : yearDifference,
    isRow: !isMobile,
    isMyVehicle: props.isMyVehicle,
    'data-testid': suffixTestId('year', props),
  };

  return (
    <>
      <Hide onMobile>
        <Box flex={1}>
          <VerticalValue {...valueProps} />
        </Box>
      </Hide>

      <Show onMobile>
        <HStack justify="space-between" align="center">
          <Text size="xSmall" color="secondary">
            {i18n.t('entity.table.firstRegistration')}
          </Text>
          <HorizontalValue {...valueProps} />
        </HStack>
      </Show>
    </>
  );
}
